import *  as _ from "lodash";
import * as $ from "jquery";
import { Util } from "./util";
import { WorkBookBase } from "./spread/spread";



class AutoFit {
    /** */
    constructor() {
        this.init();
    }

    /** */
    private init() {
        //
        this.setEvents();
    };

    /** */
    private setEvents() {

        //ここでは実装しない！あくまで中枢のsite.tsにて実装（イベントの発動タイミングが前後する恐れがある）
        // $(window).off('resize', this.fitScreen.bind(this));
        // $(window).off('shown.bs.collapse', this.fitScreen.bind(this));
        // $(window).off('hidden.bs.collapse', this.fitScreen.bind(this));
        // $(window).off('completed.spirit.pageBase', this.fitScreen.bind(this));

        // $(window).on('resize', this.fitScreen.bind(this));
        // $(window).on('shown.bs.collapse', this.fitScreen.bind(this));
        // $(window).on('hidden.bs.collapse', this.fitScreen.bind(this));
        // $(window).on('completed.spirit.pageBase', this.fitScreen.bind(this));
    };

    /**
     * @param e
     */
    fitScreen(e?) {
        let components = $('[data-autofit]');
        components.each((i, comp) => {

            let $comp = $(comp);
            //DOM上で見えている物のみ
            if ($comp.is(':hidden')) { return; }

            // 要素の位置座標を取得
            let clientRect = comp.getBoundingClientRect();
            // 画面の左端から、要素の左端までの距離
            let x = clientRect.left;
            // 画面の上端から、要素の上端までの距離
            let y = clientRect.top;
            // ページの左端から、要素の左端までの距離(スクロール加味)
            var px = window.pageXOffset + clientRect.left;
            // ページの上端から、要素の上端までの距離(スクロール加味)
            var py = window.pageYOffset + clientRect.top;


            const _minHeight = 300;
            let autoFitMinHeight = $comp.data('autofitMinHeight') ? parseInt($comp.data('autofitMinHeight')) : null;
            let minHeight = autoFitMinHeight || _minHeight;
            let newHeight = minHeight

            //画面高さがminHeightよりも小さい場合はキャンセル(minHeightで調整)
            //if (window.innerHeight > y) {
            if (window.innerHeight > py) {
                //newHeight = window.innerHeight - y;
                newHeight = window.innerHeight - py;
                if (newHeight < minHeight) {
                    newHeight = minHeight
                }
                newHeight = newHeight - 35;//Padding?? 
            }

            //Extention
            let mobileHeight = $comp.data('mobileHeight') ? parseInt($comp.data('mobileHeight')) : null;
            if (Util.screenMode.isMobile()) {
                if (mobileHeight) {
                    newHeight = mobileHeight
                }
            }

            $comp.height(newHeight);

            //spreadがある場合 リフレッシュする（wijmo-FlexGridは必要無要だ）

            //自身を含め,子要素も捜索[data-autofit]がGrid対象そのものについているわけではい！コンテナについていても動作するように....
            let spreads = $(comp).find('[gcuielement="gcSpread"]').addBack().filter('[gcuielement="gcSpread"]');
            spreads.each((i, elm) => {
                let $elm = $(elm);

                //対象コンテナの高さを調整したとて、Grid自体の高さが瞬時に変わるわけでない為、offsetParentのoverflowがvisibleのままだと、
                //scrollParentのscrollの表示有無に支障をきたす。
                //その為、最適化後のサイズでも、スクロールバーが残っており、その状態でrefreshしても、ちゃんとしたサイズに最適化されない
                //よって、親コンテナがoverflow:visibleだった場合に備え、一度強制的にoverflow：hiddenにして、スクロールバーの表示有無の最適化を行ってからrefreshする
                //(本当は全ての対象要素のscrollParentに対し掛けるべき！)
                //わざとoverflow-hidden（bootstrap）は使用せず、overflow-suspend（カスタム定義）を使用する（overflow-hiddenが既についている場合も考慮）
                //因みにbodyのoverflowをoverlay(外側にスクロール領域が出ない)にすればこの処理は不要!!

                $elm.addClass('overflow-suspend');

                if ($elm.data(WorkBookBase.DATA_KEY)) {
                    const spread: WorkBookBase = $comp.data(WorkBookBase.DATA_KEY);
                    spread?.refresh();
                } else {
                    //Lucky!!spreadjsが内部で入れてくれている（基盤を使用していないケースが考えられるので...その為のバックアッププラン）
                    $elm.data('workbook')?.refresh();
                }

                $elm.removeClass('overflow-suspend');

            });

            //
            $('body').trigger('autoFited.spirit', { target: components });

        });
    }
}


/** singleton */
export const _AutoFit = (function () {
    //documentのdataに隠ぺいし、いつでも使用できるようにする
    let _af: AutoFit = $(document).data('autoFit');
    if (!_af) {
        _af = new AutoFit();
        $(document).data('autoFit', _af);
    }
    return _af;
})();
